<template>
  <v-tooltip bottom z-index="600">
    <template #activator="{on}">
      <v-chip v-on="on" :color="color" :text-color="textColor"> <v-icon class="small mr-1 my-2">fa-train</v-icon>{{ text }}</v-chip>
    </template>
    <div>
      <h2>{{ $t("travelService.types.rail") }} ({{ $t("global.request") }})</h2>
      {{ $t("travelService.departureRailPlace") }}: {{ startPlaceText }}<br />
      {{ $t("travelService.arrivalRailPlace") }}: {{ endPlaceText }}<br />
      {{ $t("travelService.class") }}: {{ seatClassText }}<br />
      {{ $t("travelService.departureRailDate") }}: {{ travelServiceOrderItem.rail.start_date }} {{ travelServiceOrderItem.rail.start_time }}<br />
      {{ $t("travelService.isReturnRoute") }} <v-icon small v-if="travelServiceOrderItem.rail.return_date !== null" color="success">fa-check</v-icon>
      <v-icon small v-else color="error">fa-times</v-icon> <br />
      <template v-if="travelServiceOrderItem.rail.return_date !== null">
        {{ $t("travelService.returnRailDate") }}: {{ travelServiceOrderItem.rail.end_date }} {{ travelServiceOrderItem.rail.end_time }}<br />
      </template>
    </div>
    <travel-service-order-item-common-tooltip-part :travel-service-order-item="travelServiceOrderItem" />
  </v-tooltip>
</template>

<script>
import { allRailClassTypes } from "../../../staticData/TravelServiceTypes";

import TravelServiceOrderItemCommonTooltipPart from "./TravelServiceOrderItemCommonTooltipPart";
export default {
  name: "TravelServiceOrderItemRailChip",
  components: { TravelServiceOrderItemCommonTooltipPart },
  props: {
    travelServiceOrderItem: { required: true, type: Object },
    color: { required: false, type: String, default: "" },
    textColor: { required: false, type: String, default: "" },
    text: { required: false, type: String, default: "Usługa przewozu kolejowego" }
  },
  data: () => ({
    startPlaceText: "",
    endPlaceText: ""
  }),
  watch: {
    "travelServiceOrderItem.rail.start_place_id"() {
      this.downloadStartPlace();
    },
    "travelServiceOrderItem.rail.end_place_id"() {
      this.downloadEndPlace();
    }
  },
  computed: {
    seatClassText() {
      if (typeof this.travelServiceOrderItem.rail.seat_class !== "undefined") {
        return allRailClassTypes().find(v => v.value === this.travelServiceOrderItem.rail.seat_class).text;
      }
      return "";
    }
  },
  methods: {
    downloadStartPlace() {
      if (this.travelServiceOrderItem.rail.start_place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.rail.start_place_id, type: "train_station" }).then(result => {
          this.startPlaceText = result.text;
        });
      }
    },
    downloadEndPlace() {
      if (this.travelServiceOrderItem.rail.end_place_id !== null) {
        this.$store.dispatch("Location/getLocation", { placeId: this.travelServiceOrderItem.rail.end_place_id, type: "train_station" }).then(result => {
          this.endPlaceText = result.text;
        });
      }
    }
  },
  created() {
    this.downloadStartPlace();
    this.downloadEndPlace();
  }
};
</script>

<style scoped></style>

rail:Object end_place_id:"ChIJAV--iojkPEcRzEh6PqhG6ac" is_insurance:0 return_date:null return_time:null seat_class:"second" start_date:"2019-02-13"
start_place_id:"ChIJ41zpQhwzGUcR0ehDaKL1xSI" start_time:null travel_service_order_item_id:96
